import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChartThin = ({ metricsData }) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false, // Ensures better control over height
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          color: "#768B9F",
          font: {
            size: 14,
            family: "Satoshi"
          },
          boxWidth: 10,
          padding: 30,
          boxHeight: 10,
        },
      },
      tooltip: {
        backgroundColor: "rgba(25, 21, 73, 0.90)",
        minWidth: 230,
        mode: "index",
        intersect: false,
        caretPadding: 10,
        titleAlign: "center",
        padding: {
          left: 25,
          right: 30,
          top: 10,
          bottom: 10,
        },
        displayColors: false,
        callbacks: {
          title: function () {
            return ""; 
          },
          label: function (context) {
            const value = context.formattedValue;
            const labelType = context.datasetIndex === 1 ? "Churned" : "Retained";
            return `${labelType}  .  ${value}%`; // Adds letter spacing
          },
        },
        bodyFont: {
          family: "Arial, sans-serif",
          size: 14,
          weight: "bold",
        },
        titleFont: {
          family: "Arial, sans-serif",
          size: 14,
          weight: "bold",
        },
      }
    },
    scales: {
      x: {
        border: {
          display: false,
        },
        grid: {
          display: true, 
        },
        ticks: {
          autoSkip: false, 
        },
        offset: true,
      },
      y: {
        grace:"30%",
        beginAtZero: true,
        grid: {
          display: false, 
        },
        border: {
          display: false,
        },
        ticks: {
          callback: (value) => `${value.toLocaleString()}`,
          maxTicksLimit: 7,
        },
      },
    },
    barThickness: 22,
  };

 


  const data = {
    labels: 
    [
      "Jan",
      "Feb",
      "Apr",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec"
  ],
    datasets: [
      {
        label: "2024",
        data: [20, 30 , 40, 50, 50 , 100 , 100, 90, 88, 70 , 90], 
        backgroundColor: [
          "#16CA7C"
        ],
        borderColor: "#16CA7C", 
        borderWidth: 0, 
        borderRadius: 2, 
      },
      {
        label: "2025",
        data: [10, 5 , 20, 25, 25 ,30 , 10, 9 , 50, 40 , 89], 
        backgroundColor: [
          "#FF0000"
        ],
        borderColor: "#FF0000", 
        borderWidth: 0, 
        borderRadius: 2, 
      },
    ],
  };
  

  let hoverValue; 

const hoverSegment = {
  id: "hoverSegment",

  beforeDatasetsDraw(chart, args, plugins) {
    const { ctx, chartArea: { top, bottom, left, right, width, height }, scales: { x } } = chart;

    ctx.save();

    if (hoverValue !== undefined) {
      const hoverX = x.getPixelForValue(hoverValue); // Convert hoverValue to pixel

      // Dynamically calculate width based on chart width
      const datasetLength = chart.data.labels.length; // Get number of bars or points
      const hoverWidth = width / datasetLength * 1; // Adjust width dynamically

      ctx.fillStyle = "rgba(255, 251, 1, 0.3)"; // Lower opacity for #FFFB01 (Yellow)
      ctx.fillRect(hoverX - hoverWidth / 2, top, hoverWidth, height);
    }
  },

  afterEvent(chart, args, plugins) {
    const { chartArea: { left, right }, scales: { x } } = chart;
    const prevHoverValue = hoverValue; // Store previous value

    if (args.inChartArea) {
      hoverValue = x.getValueForPixel(args.event.x); // Get X-axis value
    } else {
      hoverValue = undefined;
    }

    // Prevent unnecessary updates (fixes infinite loop)
    if (prevHoverValue !== hoverValue) {
      args.changed = true;  
      requestAnimationFrame(() => chart.draw()); // More efficient than chart.update()
    }
  }
};


  

  return (
    <div style={{ height: "500px", display: "flex", alignItems: "center" }}>
      <Bar options={options} data={data}  plugins={[hoverSegment]} />
    </div>
  );
};

export default BarChartThin;